"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const groupCustomPropertiesByCtx = function () {
  let customProperties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return customProperties.reduce((acc, curr) => {
    const ctx = curr.ctx ?? 'isNull';
    const returnObj = {
      ...acc
    };
    returnObj[ctx] = [...(acc?.[ctx] ?? []), curr];
    return returnObj;
  }, {});
};
var _default = exports.default = groupCustomPropertiesByCtx;